/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-color-palette-by-brand block)");
/* eslint-enable no-console */
(function () {
    window.addEventListener('DOMContentLoaded', () => {
        const COPY_ICON = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>`;
        const CHECK_ICON = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>`;

        const toast = document.getElementById('bcToast');
        const count = document.getElementById('bcCount');
        const empty = document.getElementById('bcEmpty');
        const clearBtn = document.getElementById('bcClear');
        let toastTimer;

        function showToast(msg) {
            clearTimeout(toastTimer);
            toast.textContent = msg;
            toast.classList.add('show');
            toastTimer = setTimeout(() => toast.classList.remove('show'), 1800);
        }

        function copyText(text) {
            navigator.clipboard.writeText(text).catch(() => {
                const ta = document.createElement('textarea');
                ta.value = text; document.body.appendChild(ta);
                ta.select(); document.execCommand('copy');
                document.body.removeChild(ta);
            });
        }

        // Copy buttons
        document.querySelectorAll('.bc-copy-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const hex = btn.dataset.hex;
                copyText(hex);
                btn.innerHTML = CHECK_ICON;
                btn.classList.add('copied');
                showToast('Copied ' + hex);
                setTimeout(() => { btn.innerHTML = COPY_ICON; btn.classList.remove('copied'); }, 1500);
            });
        });

        // Download palette via Canvas
        function downloadPalette(title, slug, colors) {
            const n = colors.length;
            const SW = 140, SH = 110, PAD = 20, TITLE_H = 44, LABEL_H = 30;
            const W = n * SW + PAD * 2;
            const H = TITLE_H + SH + LABEL_H + PAD;

            const canvas = document.createElement('canvas');
            canvas.width = W * 2;
            canvas.height = H * 2;
            const ctx = canvas.getContext('2d');
            ctx.scale(2, 2);

            // Background
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, W, H);

            // Title only (no separator line cutting it)
            ctx.fillStyle = '#111111';
            ctx.font = 'bold 15px -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
            ctx.fillText(title + ' — Brand Colors', PAD, PAD + 16);

            // Swatches start below title with spacing
            const Y_SWATCH = TITLE_H;

            colors.forEach((hex, i) => {
                const x = PAD + i * SW;
                const sw = SW - 10;

                // Rounded rect swatch
                ctx.beginPath();
                ctx.roundRect(x, Y_SWATCH, sw, SH, 8);
                ctx.fillStyle = '#' + hex;
                ctx.fill();
                ctx.strokeStyle = '#000000';
                ctx.lineWidth = 1;
                ctx.stroke();

                // Hex pill below swatch
                const hexUpper = '#' + hex.toUpperCase();
                ctx.font = '11px "SFMono-Regular", Consolas, monospace';
                const tw = ctx.measureText(hexUpper).width;
                const pillW = tw + 12;
                const pillX = x + (sw - pillW) / 2;
                const pillY = Y_SWATCH + SH + 6;

                ctx.beginPath();
                ctx.roundRect(pillX, pillY, pillW, 20, 4);
                ctx.fillStyle = '#f0f0f0';
                ctx.fill();
                ctx.strokeStyle = '#dddddd';
                ctx.lineWidth = 0.5;
                ctx.stroke();

                ctx.fillStyle = '#000000';
                ctx.fillText(hexUpper, pillX + 6, pillY + 14);
            });

            // Watermark
            ctx.fillStyle = '#999999';
            ctx.font = '9px sans-serif';
            ctx.fillText('whitescreen.top', W - PAD - 82, H - 6);

            canvas.toBlob(blob => {
                const a = document.createElement('a');
                a.href = URL.createObjectURL(blob);
                a.download = slug + '-brand-colors.png';
                a.click();
                URL.revokeObjectURL(a.href);
                showToast('Downloaded ' + title + ' palette');
            }, 'image/png');
        }

        document.querySelectorAll('.bc-download-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const title = btn.dataset.title;
                const slug = btn.dataset.slug;
                const colors = JSON.parse(btn.dataset.colors);
                downloadPalette(title, slug, colors);
            });
        });

        // Search (filter existing DOM rows — SEO-safe)
        const rows = Array.from(document.querySelectorAll('.bc-row'));
        const search = document.getElementById('bcSearch');
        let searchTimer;

        search.addEventListener('input', () => {
            clearTimeout(searchTimer);
            searchTimer = setTimeout(() => {
                const q = search.value.trim().toLowerCase();
                let visible = 0;
                rows.forEach(row => {
                    const match = !q
                        || row.dataset.title.includes(q)
                        || row.dataset.slug.includes(q)
                        || row.dataset.colors.replace(/,/g, ' ').includes(q.replace('#', ''));
                    row.style.display = match ? '' : 'none';
                    if (match) visible++;
                });
                count.textContent = visible.toLocaleString() + ' brand' + (visible !== 1 ? 's' : '');
                empty.style.display = visible === 0 ? 'block' : 'none';
            }, 180);
        });


        search.addEventListener('input', function () {
            clearBtn.style.display = this.value ? 'block' : 'none';
        });

        clearBtn.addEventListener('click', function () {
            search.value = '';
            clearBtn.style.display = 'none';
            search.dispatchEvent(new Event('input'));
            search.focus();
        });
    })
})()